import { periodCodec } from 'dashboard/components-next/filter-bar/period';

// O filtro da página de Relatórios mora na URL, e é um só para todas as abas: a
// barra do cabeçalho (FilterBar, PeriodPicker e useFilterQuery) lê e escreve só
// as chaves deste esquema, e o resto da URL (a aba, o "comparar por", a origem e
// o "Abrir por") passa intacto. Trocar de aba não perde o filtro.
//
// Os parâmetros são os dos outros relatórios (`reportFilterHelper`), e por isso
// os links de antes abrem filtrados sem tradução nenhuma: `agent_id` é o
// atendente (o `agent_id=5` do link antigo de um atendente, que abre Canais e
// times), o agente de IA vai em `power_agent_id`, e o teste em `include_tests`.
// O período vai pelo nome (`range`), com `from`/`to` só quando o nome não diz as
// datas: um link de "últimos 30 dias" continua sendo dos últimos 30 dias amanhã.
//
// Campanha, template e segmento são da aba Campanhas, e são listas: um parâmetro
// repetido por valor. Sem a vírgula do tipo `strings`: o segmento é um nome livre
// (uma lista do HubSpot, uma etiqueta), e "Clientes SP, RJ" viraria dois
// segmentos que não existem.
const listCodec = param => ({
  param,
  read: query => {
    const values = [query[param]]
      .flat()
      .filter(value => typeof value === 'string' && value.trim());
    return values.length ? [...new Set(values)] : undefined;
  },
  write: values => ({ [param]: values?.length ? [...values] : undefined }),
  default: [],
});

export const ATENDIMENTO_SCHEMA = {
  period: periodCodec(),
  agentId: { param: 'power_agent_id', type: 'id' },
  inboxId: { param: 'inbox_id', type: 'id' },
  teamId: { param: 'team_id', type: 'id' },
  userId: { param: 'agent_id', type: 'id' },
  includeTests: { param: 'include_tests', type: 'bool', default: false },
  campanha: listCodec('campanha'),
  template: listCodec('template'),
  segmento: listCodec('segmento'),
};

// Data no fuso do navegador, não toISOString(): depois das 21h em São Paulo o
// dia em UTC já virou, e o período pediria o dia de amanhã.
const pad2 = value => String(value).padStart(2, '0');
export const isoDay = unixSeconds => {
  const date = new Date(unixSeconds * 1000);
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

// Filtro → API (`atendimento/*`). O que não foi escolhido vai como `null`, que é
// "todos".
export const apiFilters = filters => ({
  since: isoDay(filters.period.from),
  until: isoDay(filters.period.to),
  includeTests: Boolean(filters.includeTests),
  agentId: filters.agentId ?? null,
  inboxId: filters.inboxId ?? null,
  teamId: filters.teamId ?? null,
  userId: filters.userId ?? null,
});
